<template>
  <!-- SAMPLE REQUEST FORM -->
  <div v-if="formValid">
    <b-modal
        id="modal-sample-request"
        cancel-variant="danger"
        ok-title="Request"
        title="Request Sample"
        @hidden="clearForm"
        @ok="requestSample"
    >
      <form>

        <div v-if="!this.batchRequest">
          <b-form-group id="form-amount-group" label="Amount:" label-for="form-amount-input">
            <b-form-input
                id="form-amount-input"
                v-model="singleSample.amount"
                :max="singleSample.amount"
                min=1
                placeholder="Enter Amount"
                type="number"
            ></b-form-input>
          </b-form-group>
        </div>

        <label title="Specify the date you would like to start using the sample">
          Date (Specify the date you would like to start using the sample(s)):
        </label>
        <functional-calendar
            v-model="sampleRequest.date" :change-month-function='true'
            :change-year-function='true' :is-dark="true"
            :is-date-picker='true'
            :is-layout-expandable="true"
            :is-typeable="true"
        ></functional-calendar>
      </form>
    </b-modal>
  </div>
</template>

<script>
import {
  handleError,
  redirectAfterCountDown,
  secureStoreGetAuthString,
  showFlashMessage,
  startLoader
} from "@/utils/util_functions";
import axios from "axios";
import {sample_request_resource} from "@/utils/api_paths";
import {FunctionalCalendar} from 'vue-functional-calendar';
import EventBus from "@/components/EventBus";

export default {
  name: "SampleRequest",
  components: {FunctionalCalendar},

  data(){
    return {
      sampleData: null,
      formValid: false, // this checks if the parent form has any errors before allowing the component to display

      batchSamples: [],
      batchRequest: false,

      singleSample: {
        code: '',
        amount: 0,
        date: {}
      },

      sampleRequest: {
        amount: 0,
        date: {},  // Assigned default js object since other types including date raised TypeError.
        /* dates are limited to make sure a request is not made for a date that has already passed or
           when the sample is no longer in retention. The maximum date is placed under compute to avoid
            onLoad errors since sample by then is not set. */
        today: new Date().toLocaleDateString('en-GB'),
      },
    }
  },

  mounted() {
    /*When this event is emitted, the parent component validation is complete, so get the formValid status from the
    * parent and display the component. Also take the samples in the payload and update the necessary variables before
    * request is sent out.*/
    EventBus.$on('complete-batch-sample-order', payload=>{
      let samples = payload['samples']
      for (let i=0; i < samples.length; i++){
        let requestedSample = {
          'code': samples[i].code,
          'amount': samples[i].requestedAmount,
        }
        this.batchSamples.push(requestedSample)
      }
      this.batchRequest = true;
      this.formValid = payload['formValid']
    })

    EventBus.$on('complete-single-sample-order', payload=>{
      this.singleSample = payload
      this.batchRequest = false;
      this.formValid = true;
    })
  },

  methods: {
    clearForm() {
      this.sampleData = null
      this.sampleRequest.date = null
      this.sampleRequest.amount = null
      this.batchSamples = []
      this.batchRequest = !this.batchRequest
    },

    requestSample: function () {
      let loader = startLoader(this)

      if (this.batchRequest){
        this.sampleData = {
          requestedSamples: this.batchSamples,
          date: this.sampleRequest.date.selectedDate,
        }
      } else if (!this.batchRequest){
        this.sampleData = {
          sample: this.singleSample.code,
          amount: this.singleSample.amount,
          date: this.sampleRequest.date.selectedDate,
        }
      }

      axios.post(sample_request_resource, {'data': this.sampleData}, {
        headers: {
          Authorization: secureStoreGetAuthString()
        }
      })
        .then((response) => {
          setTimeout(() => {
            this.clearForm()
            loader.hide()
            if (response.status === 201) {
              showFlashMessage(this, 'success', response.data['message'], '')
              redirectAfterCountDown(this, '/sample')
              EventBus.$emit('batch-request-complete', this.batchSamples) // listen to this event and reset cart
            }
          }, 1000)
        })
        .catch((error) => {
            handleError(this, error, loader)
        })
    },
  },
}
</script>
